<adm-admin-enum-select-list-multiple
  label="Tilgængelige faciliteter"
  (enumChanged)="onFacilitiesChanged($event)"
  [enumObject]="facilityEnumValues"
  [translatePipe]="facilityPipe"
  [initialValue]="control().value" />
